
export default {
  async search(word: string, language: string, count: number) {
    const query = encodeURI(word);
    return fetch(`https://imager.invacto.com/search/${language}/${query}/${count}`).then(res => res.json());
  }
}
